import { getPageNameFromLocation } from "../../pages/helpers/analytics";
import plangridTrackEvents, { trackEvent } from "./amplitudeInit-vanilla";
import getLocaleByGeoIP from "./getLocaleByGeoIP";
import updateCheckboxVisibilityForUX1Country from "./updateCheckboxVisibilityForUX1Country";

const addActiveFeatureClass = pagename => {
  const currentFeaturePath = window.location.pathname;
  const currentFeatureNode = document.querySelector(
    `.fp-index-grid-row-links-box[href="${currentFeaturePath}"]`
  );
  if (!currentFeatureNode) console.warn("No active for:", currentFeaturePath);

  if (currentFeatureNode) currentFeatureNode.classList.add("active");
};

const addCtaScrollHandler = () => {
  const ctaBtn = document.querySelector(".cta-feature-button");
  const form = document.querySelector(".fp-form");

  if (ctaBtn) {
    ctaBtn.addEventListener("click", e => {
      e.preventDefault();
      form.scrollIntoView();
    });
  }
};

const getOptions = () => document.querySelectorAll(".fp-phone-loop-option");
const getButtons = () => document.querySelectorAll(".fp-phone-loop button");

const removeAllActive = () => {
  getOptions().forEach(el => el.classList.remove("active"));
  getButtons().forEach(el => el.classList.remove("active"));
};

const addLiveLoopHandlers = () => {
  const options = getOptions();
  if (!options.length) return;
  const buttons = getButtons();
  const leftArrow = document.querySelector(".fp-phone-loop .arrow.left");
  const rightArrow = document.querySelector(".fp-phone-loop .arrow.right");
  const numberOfFeatures = options.length;
  let interval;
  let index = 0;

  interval = setInterval(() => {
    removeAllActive();
    var newIndex = (index + 1) % numberOfFeatures;
    options[newIndex].classList.add("active");
    buttons[newIndex].classList.add("active");
    index = newIndex;
  }, 5000);

  const resetInterval = () => {
    clearInterval(interval);

    interval = setInterval(() => {
      removeAllActive();
      var newIndex = (index + 1) % numberOfFeatures;
      options[newIndex].classList.add("active");
      buttons[newIndex].classList.add("active");
      index = newIndex;
    }, 5000);
  };

  leftArrow.addEventListener("click", e => {
    e.stopPropagation();
    var newIndex = index == 0 ? numberOfFeatures - 1 : index - 1;
    removeAllActive();
    resetInterval();

    buttons[newIndex].classList.add("active");
    options[newIndex].classList.add("active");

    index = newIndex;
  });

  rightArrow.addEventListener("click", e => {
    e.stopPropagation();
    var newIndex = index == numberOfFeatures - 1 ? 0 : index + 1;
    removeAllActive();
    resetInterval();

    buttons[newIndex].classList.add("active");
    options[newIndex].classList.add("active");

    index = newIndex;
  });

  options.forEach((feature, i) => {
    feature.addEventListener("click", e => {
      removeAllActive();
      e.currentTarget.classList.add("active");
      buttons[i].classList.add("active");
      index = i;
      resetInterval();
    });
  });

  buttons.forEach((button, i) => {
    button.addEventListener("click", e => {
      removeAllActive();
      e.currentTarget.classList.add("active");
      options[i].classList.add("active");
      index = i;
      resetInterval();
    });
  });
};

const addFormHandler = pagename => {
  const formNode = document.querySelector(".fp-form form");
  const formContainer = document.querySelector(".fp-form-box");

  const submitFeatureForm = () => {
    const featureForm = MktoForms2.getForm(1069);

    featureForm.onSuccess((values, followUpUrl) => {
      formContainer.classList.add("confirmation");
      trackEvent("public_web.page.engage.start", { from: pagename });
      return false;
    });

    featureForm.setValues({
      FirstName: formNode["First name"].value,
      LastName: formNode["Last name"].value,
      Email: formNode.Email.value,
      Company: formNode["Company name"].value,
      Phone: formNode.Phone.value,
      optinDataCollection: formNode.optinDataCollection.checked ? "yes" : "no",
      optinMarketingCommunications: formNode.optinMarketingCommunications
        .checked
        ? "yes"
        : "no",
    });

    featureForm.submit();
  };

  formNode.addEventListener("submit", e => {
    e.preventDefault();

    submitFeatureForm();
  });
};

const getWistiaId = () => {
  let id;
  const vidWrapper = document.querySelector(".fp-video-box");

  if (!vidWrapper) return false;

  const scripts = vidWrapper.querySelectorAll("script");

  scripts.forEach(node => {
    const { src } = node;
    const match = src.match(/.+\/(.*)\.jsonp/);

    if (match) id = match[1];
  });

  return id;
};

const attachAnalyticsToFeatureVid = () => {
  window._wq = window._wq || [];

  const id = getWistiaId();
  const pagename = getPageNameFromLocation(window.location.href);

  if (!id) return;

  _wq.push({
    id,
    onReady: function (vid) {
      vid.bind("play", () => {
        trackEvent("public_web.page.video.click", { from: pagename, id });
      });
    },
  });
};

const init = () => {
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1069);
  const pagename = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pagename);
  addActiveFeatureClass();
  addCtaScrollHandler();
  addLiveLoopHandlers();
  addFormHandler(pagename);
  getLocaleByGeoIP(updateCheckboxVisibilityForUX1Country);
};

document.addEventListener("DOMContentLoaded", init);
window.addEventListener("load", attachAnalyticsToFeatureVid);



// WEBPACK FOOTER //
// ./src/assets/js/featurePage.js